export default "__VITE_ASSET__4f63f846__"